import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const Settings: React.FC = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const hasBillingState = params.has("billing");
    const targetPath = hasBillingState ? "/app/billing" : "/app/profile";

    return <Navigate to={{ pathname: targetPath, search: location.search }} replace />;
};

export default Settings;
